'use client';
import { ComponentType } from 'react';
import { PlaceholderConfig } from '@spa/lib/react/context/PlaceholderContext';
import { Props } from './service-teaser-list.component';
import dynamic from 'next/dynamic';

const DynamicServiceTeaserListComponent: ComponentType<Props> = dynamic(
  () => import('./service-teaser-list.component')
);

export default DynamicServiceTeaserListComponent;

export function calculateServiceTeaserListPlaceholderConfig(): PlaceholderConfig {
  return {
    heightSinceWidth: [
      { sinceWidth: 0, height: 220 },
      { sinceWidth: 768, height: 160 }
    ]
  };
}
